import ContentHeading from "@/components/content-heading";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import globalData from "@/i18n/json/global/data.json";
// Tailwind Classes
import { wrapper, details, detailItem, icon, strong } from "./styles";

const ContactDetails = () => {
  const { t } = useTranslation();
  return (
    <section
      className={wrapper}
      aria-label={"White background with hearX contact information"}
      title={"hearX Group contact information"}
    >
      <ContentHeading
        h="p"
        className="justify-center"
        backdropPosition="left-4"
        fontSize="mobile:text-2xl tablet:text-4xl"
        background="bg-primary bg-opacity-40"
      >
        {t("contact.heading")}
      </ContentHeading>
      <div className={details}>
        <ul>
          <li className={detailItem}>
            <LazyLoadImage
              className={icon}
              src="/assets/icons/contact/email.svg"
            />
            <a href="mailto:info@hearxgroup.com" className="GA4-ContactUsEmail">
              {globalData["contact-details"].email}
            </a>
          </li>
          <li className={detailItem}>
            <LazyLoadImage
              className={icon}
              src="/assets/icons/contact/phone.svg"
            />
            <a id="link-call-us" href="tel:(415) 212-5500" className="GA4-ContactUsCall">
              <strong className={strong}>US:</strong>
              {globalData["contact-details"].telephone.us}
            </a>
          </li>
          <li className={detailItem}>
            <LazyLoadImage
              className={icon}
              src="/assets/icons/contact/phone.svg"
            />
            <a id="link-call-za" href="tel:+27(0) 12 030 0268" className="GA4-ContactUsCall">
              <strong className={strong}>RSA:</strong>
              {globalData["contact-details"].telephone.rsa}
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ContactDetails;
